/**
 * "Acesso rápido" at the top of the left menu (owner, 10/10/2026): the quick, sensitive switches, one click each —
 * commands from elsewhere reach my agents, and teammates may send work to my agents. Both on by default; the full
 * screen for them stays in Agentes › Comandos de fora (TeamWorkSwitch, RemoteSwitch's page).
 */

import { useQuery } from '@tanstack/react-query'
import { Users } from 'lucide-react'
import { api } from '../lib/api'
import { useI18n } from '../lib/i18n'
import { useTeamWorkToggle } from '../lib/teamWorkToggle'
import { RemoteSwitch } from './RemoteSwitch'

export function QuickAccess() {
  const { t } = useI18n()
  return (
    <div className="sidebar__quick" role="group" aria-label={t('quick.title')}>
      <span className="sidebar__quick-title tiny muted">{t('quick.title')}</span>
      <RemoteSwitch />
      <TeamSwitch />
    </div>
  )
}

/** Teammates may send my agents work (an analysis, an audit, a step of team work); every such command shows in my thread. */
function TeamSwitch() {
  const { t } = useI18n()
  const { data, isError } = useQuery({ queryKey: ['remote'], queryFn: api.remote.overview, refetchInterval: 60_000, retry: false })
  // Somebody who works alone has no teammate to send them anything: the switch would only puzzle (51, D4).
  const { data: mates } = useQuery({ queryKey: ['teammates'], queryFn: () => api.workOrders.teammates(), retry: false, staleTime: 5 * 60_000 })
  const { set, dialog } = useTeamWorkToggle()

  if (isError || !data || !mates?.some((m) => !m.isMe)) return null
  // Off by default (docs/refactor/63): no answer from the server is never "on".
  const on = data.acceptTeamWork ?? false
  const title = on ? t('quick.teamOnHint') : t('quick.teamOffHint')
  return (
    <label className={`sidebar__remote${on ? ' is-on' : ''}`} title={title}>
      <input type="checkbox" checked={on} disabled={set.isPending} onChange={(event) => set.mutate(event.target.checked)} aria-describedby="sidebar-team-hint" />
      <Users size={14} aria-hidden />
      <span className="sidebar__remote-label">{t('quick.team')}</span>
      <span id="sidebar-team-hint" className="sr-only">{title}</span>
      {dialog}
    </label>
  )
}
